import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const orderApiService = createApi({
  reducerPath: 'orderApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/order/'),
  endpoints: (builder) => ({
    getOrders: builder.query({
      query: (args) => {

        let { id, currentPage, itemsPerPage, role, search, sortBy, to, from, customer } = args

        if (id) {
          return `get/${id}`
        }

        return `get?page=${currentPage}&rowsPerPage=${itemsPerPage}${(search && search !== '') ? `&search=${search}` : ``}${(sortBy && sortBy !== '') ? `&sortBy=${sortBy}` : ``}${(customer && customer !== '') ? `&customer=${customer}` : ``}${(from && from !== '') ? `&from=${from}` : ``}${(to && to !== '') ? `&to=${to}` : ``}`
      },
      keepUnusedDataFor: 0
    }),
    updateOrderStatus: builder.mutation({
      query: (args) => {

        let { id, payload } = args
        let url = `update/${id}`

        return ({
          url,
          method: 'PUT',
          body: payload
        })

      }
    }),
  })
})

export const {
  useGetOrdersQuery,
  useUpdateOrderStatusMutation
} = orderApiService